import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import getPartnerCartReviewsQueryKey from "../../../partner_cart_reviews/v1/get-query-key";

/**
 * Updates partner cart reviews v1 totals
 *
 * @param {object} params - named parameters
 * @param {object} params.queryClient - the query client
 * @param {number} params.summarySubtotal - subtotal amount
 * @param {number} params.summaryTotal - total amount
 */
var updatePartnerCartReviewsV1 = function updatePartnerCartReviewsV1(_ref) {
  var _partnerCartReviews$t;
  var queryClient = _ref.queryClient,
    summarySubtotal = _ref.summarySubtotal,
    summaryTotal = _ref.summaryTotal;
  var isCartEmpty = summaryTotal === 0 && summarySubtotal === 0;
  var partnerCartReviews = queryClient.getQueryData(getPartnerCartReviewsQueryKey());
  var summaryShippingTotal = isCartEmpty ? 0 : (partnerCartReviews === null || partnerCartReviews === void 0 || (_partnerCartReviews$t = partnerCartReviews.totals) === null || _partnerCartReviews$t === void 0 ? void 0 : _partnerCartReviews$t.shippingTotal) || 0;
  queryClient.setQueryData(getPartnerCartReviewsQueryKey(), function (partnerCartReviews) {
    return _objectSpread(_objectSpread({}, partnerCartReviews), {}, {
      totals: {
        subtotal: summarySubtotal,
        taxTotal: 0,
        taxTotalDetails: {
          internationalCharges: 0,
          internationalChargesType: 'NOT_APPLICABLE'
        },
        discountTotal: 0,
        total: summaryTotal + summaryShippingTotal,
        shippingTotal: summaryShippingTotal
      }
    });
  });
};
export default updatePartnerCartReviewsV1;